// 证件类型
export enum CARD_TYPE {
    PER = 'person_card_type',
    ORG = 'org_card_type'
}

// 性别
export const SEX = [
    {
        label: '男',
        value: '1'
    },
    {
        label: '女',
        value: '2'
    }
];

export const CARD_VAL = ['111', '112', '113'];
